import CreateProcess from './CreateProcess'

const ContractProcessButtons = {
    Create: CreateProcess,
}
export default ContractProcessButtons
